<ion-content scrollbar class="modal-outher-container">
  <ion-grid
    class="modal-inner-container edit-floor__container custom-scrollbar"
  >
    <ion-row>
      <ion-col>
        <app-modal-header
          *ngIf="!floorId"
          header="{{ 'BUILDING.NEW_FLOOR' | translate }}"
          (close)="close()"
        >
        </app-modal-header>

        <app-modal-header
          *ngIf="floorId"
          header="{{ 'BUILDING.EDIT_FLOOR' | translate }}"
          (close)="close()"
        >
        </app-modal-header>

        <form
          [formGroup]="form"
          (ngSubmit)="Save()"
          class="edit-floor__form-container"
        >
          <app-input
            type="input"
            [form]="form"
            formControlName="name"
            [readonly]="!permissionEditFloor"
            label="NAME"
            [submittedError]="validationError"
          ></app-input>
        
          <app-input
            type="textarea"
            [form]="form"
            formControlName="description"
            [autoGrow]="growAuto"
            (ionInput)="onInput()"
            [rows]="2"
            [readonly]="!permissionEditFloor"
            label="DESCRIPTION"
            [submittedError]="validationError"
          ></app-input >

          <app-input
            type="number"
            [form]="form"
            formControlName="level"
            [readonly]="!permissionEditFloor"
            label="LEVEL"
            [submittedError]="validationError"
            [customErrors]="[{
              message: 'ADD_COMPANY.NUMBER_BETWEEN',
              code: 'notNumber'
            },
            {
              message: 'ADD_COMPANY.NUMBER_BETWEEN',
              code: 'notInRange'
            }]"
          ></app-input>

          <ion-item class="input" lines="none" *ngIf="permissionEditFloor">
            <app-upload-attachment
              [attachment]="filePath"
              uploadAttachmentButtonText="{{ 'FLOOR.ADD_FLOOR_PLAN' | translate }}"
              changeAttachmentButtonText="{{ 'FLOOR.EDIT_FLOOR_PLAN' | translate }}"
              [controlName]="'file'"
              (attachmentUploaded)="imageUploaded($event)"
              (attachmentRemoved)="imageRemoved($event)"
            >
              FLOOR.ADD_FLOOR_PLAN
            </app-upload-attachment>
          </ion-item>

          <ion-item lines="none" class="input" *ngIf="permissionEditFloor">
            <ion-button
              *ngIf="floorId"
              class="button-margin-top-md"
              slot="start"
              fill="outline"
              size="medium"
              color="primary"
              (click)="deleteFloor()"
              >{{ 'DELETE' | translate}}</ion-button
            >

            <ion-button
              type="submit"
              class="button-margin-top-md"
              size="medium"
              slot="end"
              [disabled]="disableSaveButton"
            >
              <ng-container *ngIf="!disableSaveButton"
                >{{'SAVE' | translate}}</ng-container
              >
              <ng-container *ngIf="disableSaveButton"
                >{{'SAVING' | translate}}</ng-container
              >
            </ion-button>
          </ion-item>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
